module.exports = __webpack_public_path__ + "static/media/sel_02_228.fbf5ccbb.mp4";